<template>
  <div class="financingChain">
    <el-row class="financingChain_container">
      <el-col :span="24" class="panel-top">
        <div class="container">
          <el-dropdown
            v-if="!isSupervisionMode"
            class="global-drop-down"
            placement="top-start"
            @command="handleCommand"
            :hide-on-click="false"
          >
            <GlobalIcon class="global-icon"></GlobalIcon>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="item.languageCode"
                v-for="(item, index) in languages"
                :key="index"
                :class="{
                  'dropdown-item-active': item.languageCode == currentLanguage
                }"
              >
                {{ item.languageName }} ({{ item.languageDisplayName }})
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-col :span="8" class="head_left">
            <span class="logo" @click="$router.push({ path: '/aboutUs' })" v-if="isSupervisionMode">
              <img src="../common/images/logo.png" />
            </span>
            <span class="logo" @click="$router.push({ path: '/home' })" v-else>
              <img src="../common/images/logo.png" />
            </span>
          </el-col>
          <el-col :span="16" class="menu-list">
            <span
              v-if="!isSupervisionMode"
              @click="$router.push({ path: '/home' })"
              :class="selectIndex == 1 ? 'active' : ''"
              class="menu_item"
              >{{ $t("主页") }}</span
            >
            <el-popover
              v-if="!isSupervisionMode"
              popper-class="servicePover"
              v-model="showService"
              placement="bottom"
              trigger="hover"
            >
              <div class="selectList">
                <div
                  class="selectItem"
                  @click="changeService(0)"
                  :class="activeServiceIndex === 0 ? 'activeService' : ''"
                >
                  {{ $t("核心企业") }}
                </div>
                <div
                  class="selectItem"
                  @click="changeService(1)"
                  :class="activeServiceIndex === 1 ? 'activeService' : ''"
                >
                  {{ $t("供应商") }}
                </div>
                <div
                  class="selectItem"
                  @click="changeService(2)"
                  :class="activeServiceIndex === 2 ? 'activeService' : ''"
                >
                  {{ $t("增值服务") }}
                </div>
              </div>
              <span
                slot="reference"
                @click="
                  activeServiceIndex = 0;
                  $emit('changeService', 0);
                  $router.push({ path: '/service' });
                "
                :class="selectIndex == 2 ? 'active' : ''"
                class="menu_item menu_item_service"
              >
                {{ $t("产品服务") }}
              </span>
            </el-popover>

            <span
              v-if="!isSupervisionMode"
              @click="$router.push({ path: '/news' })"
              :class="selectIndex == 3 ? 'active' : ''"
              class="menu_item"
              >{{ $t("新闻动态") }}</span
            >
            <span
              @click="$router.push({ path: '/aboutUs' })"
              :class="selectIndex == 4 ? 'active' : ''"
              class="menu_item last"
              >{{ $t("关于我们") }}</span
            >
            <span
              :class="{ 'centered-line': isSupervisionMode }"
              v-show="!showService || $route.name != 'service'"
              class="line"
            ></span>
            <template v-if="!isSupervisionMode">
              <el-dropdown class="new-login" :hide-on-click="false">
                <span class="el-dropdown-link login-btn">
                  {{ $t("登录 | 注册")
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toLogin('supplier')">{{
                    $t("供应商系统")
                  }}</el-dropdown-item>
                  <el-dropdown-item @click.native="toLogin('fund')">{{
                    $t("资金方系统")
                  }}</el-dropdown-item>
                  <el-dropdown-item @click.native="toLogin('core')">{{
                    $t("核心企业系统")
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <!-- <span class="">|</span>
						<span @click="toRegister"  class="register">注册</span> -->
          </el-col>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Row,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popover,
  Icon
} from "element-ui";
import GlobalIcon from "./globalIcon";
import { setLanguage } from "../lang/switchLanuage";
import axios from "axios";

// 注册Element组件
Vue.use(Row);
Vue.use(Col);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Popover);
Vue.use(Icon);
export default {
  name: "sfwHeader",
  props: ["selectIndex"],
  components: { GlobalIcon },
  data() {
    return {
      activeServiceIndex: 0,
      showService: false,
      isSupervisionMode: window.websiteMode === "supervision",
      languages: [],
      currentLanguage: localStorage.getItem("lang") || "zh-CN"
    };
  },
  mounted() {
    axios.get("/official/outer/international/supportLanguage").then(res => {
      this.languages = res.data || [];
      let lang = localStorage.getItem("lang");
      if (!lang) {
        lang = "zh-CN";
      }
      setLanguage(lang);
    });
  },
  methods: {
    selectIndexChange(val) {
      if (this.isSupervisionMode) {
        return;
      }
      const line = document.getElementsByClassName("line")[0];
      if (!line) return;
      if (val == 1) {
        line.style.left = "196px";
        line.style.right = "466px";
      } else if (val == 2) {
        line.style.left = "290px";
        line.style.right = "370px";
      } else if (val == 3) {
        line.style.left = "400px";
        line.style.right = "256px";
      } else if (val == 4) {
        line.style.left = "516px";
        line.style.right = "146px";
      } else {
        line.style.display = "none";
      }
    },
    changeService(index) {
      this.activeServiceIndex = index;
      // 修复控制台报重复的"/service"错误，因此注释下面跳转的代码
      // this.$router.push({ path: "/service" });
      this.$emit("changeService", index);
    },
    toRegister() {
      window.location.href = "/signup";
    },
    toLogin(name) {
      if (name === "supplier") {
        window.open(
          window.loginUrl &&
            window.loginUrl.supplier + "?langCode=" + this.currentLanguage,
          "_blank"
        );
      } else if (name === "fund") {
        window.open(
          window.loginUrl &&
            window.loginUrl.fund + "?langCode=" + this.currentLanguage,
          "_blank"
        );
      } else if (name === "core") {
        window.open(
          window.loginUrl &&
            window.loginUrl.core + "?langCode=" + this.currentLanguage,
          "_blank"
        );
      }
    },
    handleCommand(languageCode) {
      localStorage.setItem("lang", languageCode);
      this.currentLanguage = languageCode;
      setLanguage(languageCode).then(() => {
        // window.location.reload();
      });
    }
  },
  watch: {
    selectIndex: "selectIndexChange"
  }
};
</script>
<style lang="less" scoped>
.financingChain {
  font-size: 14px;
  color: #ffffff;
  width: 100%;
  height: 60px;

  .panel-top {
    background: #091140;
    z-index: 20;
    width: 100%;

    .container {
      box-sizing: content-box;
      height: 60px;
      margin: 0 auto;
      width: 1100px;
      min-width: 1100px;
      background-color: transparent;
      position: relative;
    }

    .global-drop-down {
      position: absolute;
      top: 23px;
      right: -15px;
      cursor: pointer;
    }
    .global-icon {
      color: #fff;
      font-size: 16px;
    }

    .head_left {
      padding-left: 20px;
      height: 60px;
      line-height: 60px;
    }

    .menu-list {
      padding-right: 20px;
      text-align: right;
      height: 60px;
      line-height: 60px;
      position: relative;
    }

    .line {
      display: block;
      height: 3px;
      border-radius: 15px;
      left: 194px;
      right: 466px;
      position: absolute;
      background: #558fff;
      text-align: center;
      transition: right 0.3s cubic-bezier(0.35, 0, 0.25, 1),
        left 0.3s cubic-bezier(0.35, 0, 0.25, 1) 0.09s;
      bottom: 0;

      &.centered-line {
        left: auto !important;
        right: 57px !important;
        width: 70px;
      }
    }
  }

  .logo {
    width: 100%;
    height: 60px;
    line-height: 60px;
    float: left;
    margin-right: 15px;
    position: relative;
    cursor: pointer;

    img {
      width: auto;
      height: 40px;
      margin-bottom: -15px;
    }
  }

  .head_title {
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
  }

  .register {
    margin-left: 10px;
    cursor: pointer;
  }

  .login {
    // margin-left: 10px;
    // margin-right: 10px;
    cursor: pointer;
  }
  .old-login {
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
  }

  .login-btn {
    color: #fff;
  }
  .menu_item {
    cursor: pointer;
    margin-right: 40px;
    padding: 0px 5px 6px;
    height: 60px;
    line-height: 60px;
    display: inline-block;

    &.active {
      color: #558fff;
    }
  }

  .menu_item_service {
    position: relative;
  }
}

@media screen and (max-width: 1440px) {
  .financingChain .logo {
    img {
      height: 36px;
      margin-bottom: -15px;
    }
  }
}
</style>
<style lang="less">
.servicePover.el-popper {
  clear: both;
  background: transparent;
  min-width: 0;
  border: 0;
  padding: 0;
  z-index: 2000;
  color: inherit;
  line-height: 1;
  font-size: 14px;
  box-shadow: 0;
  margin-top: 4px;

  .popper__arrow {
    display: none;
  }

  .selectList {
    width: 90px;
    overflow: hidden;
    background: #091140;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
    border-radius: 1px;

    .selectItem {
      background: #091140;
      cursor: pointer;
      height: 40px;
      opacity: 0.6;
      line-height: 40px;
      font-size: 14px;
      color: #ffffff;
      text-align: left;
      padding-left: 8px;
      box-sizing: content-box;
    }

    .selectItem.activeService {
      background: #175adc;
      opacity: 1;
    }
  }
  .item-active {
    background-color: #e6f7ff;
  }
}
</style>
<style>
.dropdown-item-active {
  background-color: #e6f7ff;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue